import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/invoice";

export const getInvoiceById = (invoiceId) => axios.get(API_PATH + "/getbyid/" + invoiceId);

export const pagingInvoice = (searchObject) => axios.post(API_PATH + "/paging-invoice", searchObject);

export const pagingInvoiceByPatientId = (searchObject, patientId) => axios.post(API_PATH + '/paging-invoice/' + patientId, searchObject);

export const deleteInvoice = invoiceId => axios.delete(API_PATH + '/mark-delete/' + invoiceId);

export const updateInvoiceStatus = invoice => axios.put(API_PATH + '/update-invoice-status', invoice);

export const pagingPatientInvoice = (searchObject) => axios.post(API_PATH + "/paging-patient-invoice", searchObject);

export const saveProvisionalInvoice = (invoice) => axios.post(API_PATH + "/save-provisional-invoice", invoice);

export const updateProvisionalInvoice = (invoice, id) => axios.put(API_PATH + "/update-provisional-invoice/" + id, invoice);

export const pagingInvoiceOfCurrentTreatmentByPatientId = (searchObject) => axios.post(API_PATH + '/get-all-invoice-of-current-treatment', searchObject);

export const getPatientUnpaidInvoice = (searchObject) => axios.post(API_PATH + '/get-patient-unpaid-invoice', searchObject);

export const getAllServiceUnpaid = (searchObject) => axios.post(API_PATH + '/get-all-service-in-current-treatment', searchObject);

export const hospitalDischargePayment = (searchObject) => axios.post(API_PATH + '/hospital-discharge-payment', searchObject);

export const getAllInvoiceByEpisodeOfCare = (searchObject) => axios.post(API_PATH + '/get-all-invoice-by-episode-of-care', searchObject);

export const pagingInvoiceVisit = (searchObject) => axios.post(API_PATH + '/paging-visit-invoice', searchObject);

export const pagingVisitInvoiceHI = (searchObject) => axios.post(API_PATH + "/paging-visit-invoice-health-insurance", searchObject)

export const getListInvoiceByVisitId = (visitId) => axios.get(API_PATH + '/list-invoice-by-visitId/' + visitId);

export const getListInvoiceItemByVisitIdAndType = (visitId, invoiceItemType) => axios.get(API_PATH + '/list-invoice-item-by-visitId-itemType/' + visitId + '/' + invoiceItemType)

export const invoiceGenerateQRCode = (searchObject) => axios.post(API_PATH + '/invoice-generate-qr-code', searchObject, { responseType: 'arraybuffer' })
export const getListInvoiceItemByVisitId = (visitId) => axios.get(API_PATH + '/get-list-invoice-item-by-visitId/' + visitId)
export const getInvoicesAggregate = (id, type) => axios.get(API_PATH + '/get-invoice-aggregate/' + type + '/' + id);
export const getHICostStatement = (id, type) => axios.get(API_PATH + '/get-health-insurance-cost-statement-visit/' + id + '/' + type)
export const getInvoiceAccounting = (id) => axios.get(API_PATH + '/get-invoice-accounting/' + id)
export const getInvoiceAccountingInpatient = (id) => axios.get(API_PATH + '/get-invoice-accounting-boarding/' + id)

export const genManualInvoices = (searchObject) => axios.post(API_PATH + '/gen-manual-invoices', searchObject)

export const pagingRetailOrder = (searchObject) => axios.post(API_PATH + '/paging-invoice-retail-order', searchObject)

export const pagingVisitInvoicePatient = (searchObject) => axios.post(API_PATH + "/paging-visit-invoice-patient", searchObject)

